import React from 'react';
import PropTypes from 'prop-types';

function Weather({ resultApi }) {

    console.log(resultApi);

    // extraer valores
    const { name, main } = resultApi;


    //restar grados kelvin 
    const kelvin = 273.15;

    if (!name) {
        return null;
    }

    return (
        <div className="card-panel white col s12">
            <div className="black-text">
                <h2>The Weather in {name} is:</h2>
                <p className="temperatura">
                    {parseInt(main.temp - kelvin, 10)} <span>&#x2103;</span>
                </p>
                <p>
                    Temperatura Máxima : {parseInt(main.temp_max - kelvin, 10)} &#x2103;
                </p>
                <p>
                    Temperatura Mínima : {parseInt(main.temp_min - kelvin, 10)} &#x2103;
                </p>
            </div>
        </div>
    )
}

Weather.propTypes = {
    resultApi: PropTypes.object.isRequired
}

export default Weather;